import { render, staticRenderFns } from "./WsStateLabel.vue?vue&type=template&id=4b2dea76&"
import script from "./WsStateLabel.vue?vue&type=script&lang=js&"
export * from "./WsStateLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports